"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createResolveLocalizedString = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const LocalizedString_1 = require("./LocalizedString");
/** @see <https://docs.i18nifty.dev/api-reference/localizedstring> */
exports.createResolveLocalizedString = (0, LocalizedString_1.createResolveLocalizedStringFactory)({
    "createJsxElement": ({ text, lang }) => lang === undefined ? (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: text }) : (0, jsx_runtime_1.jsx)("span", Object.assign({ lang: lang }, { children: text }))
}).createResolveLocalizedString;
